export const ProductLine16 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect height="12" width="20" rx="3" stroke="currentColor" strokeWidth="1.5" x="2" y="6" />
  </svg>
);
